import TabHeader from "./tab-header/index.jsx"
import TabContent from "./tab-content/index.jsx"
import TabContentHideable from "./tab-content-hideable/index.jsx"

export default {
  TabHeader,
  TabContent,
  TabContentHideable,
}
